import { gql } from 'graphql-request'

export const Q_SUBSCRIPTION_DETAILS = gql`
  query SubscriptionDetails {
    subscriptionDetails {
      ... on SubscriptionDetails {
        planName
        planTier
        dailyTokenLimit
        features
        interval
        currentPeriodEnd
        status
        cancelAtPeriodEnd
        pausedUntil
      }
      ... on QueryFailure {
        errors {
          message
        }
      }
    }
  }
`
